import creditoService from '@/servicios/credito'
import { ERROR_ACTUALIZA_ESTATUS_SOLICITUD } from '@/utilidades/errores'

export const ActualizaEstatusSolicitudMixin = {
  data: () => ({
    consumiendoActualizaEstatusSolicitud: false,
  }),
  methods: {
    // Metodos publicos
    actualizaEstatusSolicitud(idSolicitud = null) {
      this.$_ActualizaEstatusSolicitudMixin_IniciaActualizaEstatusSolicitud()
      const ase = this.$store.getters['credito/obtenerAse']
      creditoService
        .actualizarEstatusSolicitud(idSolicitud, ase)
        .then((result) => {
          this.$_ActualizaEstatusSolicitudMixin_TerminaActualizaEstatusSolicitud()
          if (result.status != 200) {
            this.errorActualizaEstatusSolicitud(
              ERROR_ACTUALIZA_ESTATUS_SOLICITUD
            )
            return
          }
          const data = result.data
          if (data.Codigo != 200) {
            this.errorActualizaEstatusSolicitud(data.Mensaje)
            return
          }
          this.postActualizaEstatusSolicitud(data.Modelo)
        })
        .catch((err) => {
          this.$_ActualizaEstatusSolicitudMixin_TerminaActualizaEstatusSolicitud()
          console.error(err)
          this.errorActualizaEstatusSolicitud(ERROR_ACTUALIZA_ESTATUS_SOLICITUD)
        })
    },
    postActualizaEstatusSolicitud() {},
    errorActualizaEstatusSolicitud(mensaje) {
      console.error(mensaje)
    },

    // Metodos privados
    $_ActualizaEstatusSolicitudMixin_IniciaActualizaEstatusSolicitud() {
      this.consumiendoActualizaEstatusSolicitud = true
    },
    $_ActualizaEstatusSolicitudMixin_TerminaActualizaEstatusSolicitud() {
      this.consumiendoActualizaEstatusSolicitud = false
    },
  },
}
